export default __webpack_public_path__ + "static/media/mob_welcome_background.fabd3343.png";